<span [ngClass]="css">{{ kpiValue }}</span>
